let tokenGetter = null
let signOutFn = null

export const setClerkSessionAccessors = ({ getToken, signOut }) => {
  tokenGetter = getToken
  signOutFn = signOut
}

export const clearClerkSessionAccessors = () => {
  tokenGetter = null
  signOutFn = null
}

export const getClerkSessionToken = async () => {
  if (!tokenGetter) return ''
  return (await tokenGetter()) || ''
}

export const signOutClerkSession = async () => {
  if (!signOutFn) return
  await signOutFn()
}
